export const productId_order = 15//预售产品id
export const productId_go = 18//现货产品id

export const productPrice_order = 20 //预售价格
export const productPrice_go =330 //预售价格

export const giftQuantity = 30//赠品数量

export const order_begin = "2018-07-31 10:30:00"
export const order_end = "2018-08-03 23:59:59"

export const go_begin = "2018-08-04 00:00:00"
export const go_end = "2018-08-12 23:59:59"

export const OrderProduct = {
    id:72037,
    price:20,
    name:"会员尊享牛奶套餐 预约",
    content:[
        
    ],
    orderDetail:[
        "芒果TV全屏会员月卡（已充）",
        "会员尊享牛奶套餐购买资格"
    ],
    description:[
        "1、芒果TV全屏会员月卡1张（即时充入当前账户）",
        "2、“买芒果TV全屏会员年卡配牛奶盒子”活动参与资格"
    ]
}
export const GoProduct = {
    id:72038,
    price:330,
    name:"会员尊享牛奶套餐 现货首发",
    content:[
        
    ],
    orderDetail:[
        "芒果TV全屏会员年卡（已充）",
        "牛奶盒子（会员尊享赠品）",  
    ],
    wuliu:[
        "您订购的商品将于活动结束后一周内发货",
        "20000台首发现货已抢购完毕，第二批商品预计将于60天内安排发货，敬请留意"
    ],
    description:[
        "1、芒果TV全屏会员年卡1张（即时充入当前账户）",
        "2、牛奶盒子（会员尊享赠品）"
    ]
}

export const pageConfig={
    order:{
        title:"牛奶盒子首发活动"
    },
    go:{
        title:"牛奶盒子首发活动"
    }
}



// WEBPACK FOOTER //
// ./src/constant/products.js